export const WHATSAPP_NUMBER = "5561984563435";

export const waLink = (message) =>
  `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`;

export const MESSAGES = {
  hero: "Olá! Vim pelo site do Salão Estrela e gostaria de conhecer as opções de cabelos.",
  header: "Olá! Gostaria de atendimento do Salão Estrela.",
  extensao: "Olá! Tenho interesse em saber mais sobre Extensão Capilar e Mega Hair no Salão Estrela.",
  cabeloHumano: "Olá! Gostaria de consultar as opções de Cabelo Humano 100% Natural.",
  perucas: "Olá! Quero consultar modelos e valores de Perucas no Salão Estrela.",
  topos: "Olá! Gostaria de informações sobre Topos Capilares e Próteses.",
  especialista: "Olá! Quero falar com uma especialista do Salão Estrela para encontrar minha opção ideal.",
  flutuante: "Olá! Gostaria de atendimento pelo WhatsApp do Salão Estrela.",
  transformacao: "Olá! Vi as transformações de antes e depois no site e quero transformar meu visual!",
  compraCabelo: "Olá! Quero vender meu cabelo. Podem fazer uma avaliação?",
  servicosSalao: "Olá! Quero agendar um serviço no Salão Estrela (corte, escova, manicure ou unhas em gel).",
};

export const IMAGES = {
  hero: "/images/hero-depois.jpg",
  extensao: "/images/card-extensao.jpg",
  cabeloHumano: "/images/card-cabelo.jpg",
  perucas: "/images/card-perucas.jpg",
  topos: "/images/card-topos.jpg",
  transf1: "/images/transf1.jpg",
  transf2: "/images/transf2.jpg",
  transf3: "/images/transf3.jpg",
  fachada: "/images/fachada.jpg",
  salao: "/images/salao.jpg",
  placaCompramos: "/images/placa-compramos.jpg",
};

export const CONTACT = {
  instagram: "@apliquesestrela",
  instagramUrl: "https://instagram.com/apliquesestrela",
  address: "Quadra 8, Bloco 12, Loja 06, Sobradinho — Brasília/DF",
  phone: "(61) 98456-3435",
  phoneUrl: "tel:+5561984563435",
};
